module.exports = __webpack_public_path__ + "static/media/rbc.9587f4c4.png";